<template>
  <div class="home-page" :class="theme">
    <!-- Navigation Menu -->
    <nav class="menu">
      <button
        v-for="view in views"
        :key="view.value"
        @click="selectView(view.value)"
        :class="{ active: selectedView === view.value }"
      >
        {{ view.text }}
      </button>
    </nav>

    <div class="view-container">
      <!-- Vue détail projet -->
      <ProjectDetail
        v-if="selectedProject"
        :project="selectedProject"
        :number-of-images="selectedProject.images.length"
        :closeProjectDetail="closeProjectDetail"
        :getCarouselImage="getCarouselImage"
        :isYouTubeVideo="isYouTubeVideo"
        :isVimeoVideo="isVimeoVideo"
        :getYouTubeEmbedUrl="getYouTubeEmbedUrl"
        :getVimeoEmbedUrl="getVimeoEmbedUrl"
        :theme="theme"
      />

      <!-- Vue principale -->
      <template v-else>
        <ProjectGrid
          v-if="selectedView === 'projects'"
          :key="projectGridKey"
          :filteredProjects="filteredProjects"
          :formatOptions="formatOptions"
          :theme="theme"
          @select-project="handleSelectProject"
        />
        <VFXGrid v-else-if="selectedView === 'vfx'" :theme="theme" />
        <ContactModule v-else-if="selectedView === 'contact'" :theme="theme" />
      </template>
    </div>
  </div>
</template>

<script>
import ProjectGrid from "./ProjectGrid.vue";
import VFXGrid from "./VFXGrid.vue";
import ContactModule from "./ContactModule.vue";
import ProjectDetail from "./ProjectDetail.vue";

export default {
  props: {
    theme: {
      type: String,
      required: true,
    },
  },
  components: { ProjectGrid, VFXGrid, ContactModule, ProjectDetail },
  emits: ["update-detail-mode"], // <-- on émet vers App.vue
  data() {
    return {
      selectedView: localStorage.getItem("selectedView") || "projects",
      projectGridKey: 0,
      projectsLoaded: false,
      selectedProject: null,
      allProjects: [],
      views: [
        { value: "projects", text: "Étalonnage" },
        { value: "vfx", text: "Effets Visuels" },
        { value: "contact", text: "Contact" },
      ],
      filteredProjects: [],
      formatOptions: [
        { value: null, text: "Tous" },
        { value: "music", text: "Musique" },
        { value: "doc", text: "Documentaire" },
        { value: "fiction", text: "Fiction" },
        { value: "art", text: "Art" },
      ],
    };
  },
  watch: {
    selectedProject(newVal) {
      // Notifie App.vue que l’on est en mode détail ou non
      this.$emit("update-detail-mode", !!newVal);
    },
  },
  methods: {
    selectView(view) {
      this.selectedView = view;
      this.selectedProject = null;
      localStorage.setItem("selectedView", view);

      if (view === "projects") {
        this.fetchProjects();
      }
    },

    handleSelectProject(project) {
      this.selectedProject = project;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    closeProjectDetail() {
      this.selectedProject = null;
    },

    async fetchProjects() {
      if (this.projectsLoaded) return;

      try {
        const cached = localStorage.getItem("cachedProjects");
        if (cached) {
          this.allProjects = JSON.parse(cached);
        } else {
          const res = await fetch("https://julian-nouveau.com/api.php");
          if (!res.ok) throw new Error("Error fetching projects");
          const data = await res.json();
          this.allProjects = data;
          localStorage.setItem("cachedProjects", JSON.stringify(data));
        }
        this.filteredProjects = this.allProjects;
        this.projectsLoaded = true;
      } catch (err) {
        console.error(err);
      }
    },

    // Fonctions pour ProjectDetail
    getCarouselImage(projectId, index) {
      const project = this.allProjects.find(p => p['name-id'] === projectId);
      return project?.images?.[index - 1] || "";
    },

    isYouTubeVideo(url) {
      return url.includes("youtube.com") || url.includes("youtu.be");
    },

    isVimeoVideo(url) {
      return url.includes("vimeo.com");
    },

    getYouTubeEmbedUrl(url) {
      const videoId = url.split("v=")[1] || url.split("/").pop();
      return `https://www.youtube.com/embed/${videoId}`;
    },

    getVimeoEmbedUrl(url) {
      const videoId = url.split("/").pop();
      return `https://player.vimeo.com/video/${videoId}`;
    },
  },

  mounted() {
    if (this.selectedView === "projects") this.fetchProjects();

    window.addEventListener("reset-to-etalonnage", () => {
      this.selectView("projects");
      this.selectedProject = null;
    });
  },
};
</script>

<style scoped>
.menu {
  display: flex;
  justify-content: center;
  margin-bottom: 0px;
}
.menu button {
  font-size: medium;
  border: none;
  margin: 0 20px;
  cursor: pointer;
  background-color: transparent;
  color: inherit;
}
.menu button.active {
  text-decoration: underline;
}
.menu button:hover {
  text-decoration: underline;
}
.view-container {
  padding: 10px;
}
@media (max-width: 768px) {
  .menu button { margin: 0 10px; }
  .view-container { padding: 0; }
}
</style>
